import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useTheme } from '../../hooks/useTheme';
import toast from 'react-hot-toast';
import Settings from './Settings';

const NAV = [
  { key: 'personal',  label: 'Personal',  icon: 'M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z' },
  { key: 'extra_details',     label: 'Extra Details',     icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2' },
  { key: 'family',    label: 'Family',    icon: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75' },
  { key: 'qualification', label: 'Qualification', icon: 'M22 10v6M2 10l10-5 10 5-10 5zM6 12v5c3 3 9 3 12 0v-5' },
  { key: 'contact',   label: 'Contact',   icon: 'M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.18 19.79 19.79 0 01.22 4.6 2 2 0 012.18 2.4h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 9.78a16 16 0 006.29 6.29l1.45-1.45a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z' },
  { key: 'position',  label: 'Position Type', icon: 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' },
  { key: 'payment_details', label: 'Payment Details', icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2 2z' },
  { key: 'employee',  label: 'Employee',  icon: 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' },
  { key: 'vehicles',  label: 'Vehicles',  icon: 'M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10l1.293 1.293A1 1 0 005 17h.05M13 16H9m4 0h5.5M13 6h2.586a1 1 0 01.707.293l3.414 3.414A1 1 0 0120 10.414V16a1 1 0 01-1 1h-.5' },
  { key: 'items',     label: 'Market Items', icon: 'M12 6v6m0 0v6m0-6h6m0 0h6M6 12a6 6 0 11-12 0 6 6 0 0112 0z' },
  { key: 'registration_timeline', label: 'Registration Timeline', icon: 'M5 13l4 4L19 7' },
  { key: 'meetings',  label: 'Meetings', icon: 'M3 3h18v4H3z M3 9h18v4H3z M3 15h18v4H3z' },
  { key: 'owners',    label: 'Owners',   icon: 'M12 20a8 8 0 100-16 8 8 0 000 16z' },
  { key: 'documents', label: 'Documents', icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
];

function SidebarBtn({ icon, label, active, disabled, onClick }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        width: '100%', display: 'flex', alignItems: 'center', gap: 10,
        padding: '9px 10px', borderRadius: 8, border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        background: active ? '#1d4ed8' : 'transparent',
        color: active ? '#fff' : disabled ? '#2d3f55' : '#94a3b8',
        fontSize: 13, fontWeight: active ? 500 : 400,
        marginBottom: 2, fontFamily: 'inherit',
        transition: 'all .15s',
      }}
      onMouseEnter={e => { if (!active && !disabled) e.currentTarget.style.background = '#1e293b'; }}
      onMouseLeave={e => { if (!active) e.currentTarget.style.background = 'transparent'; }}
    >
      <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d={icon}/>
      </svg>
      {label}
    </button>
  );
}

export default function Layout({ children, activeTab, onTabChange, shopId, onShopChange, shops }) {
  const { username, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [showSettings, setShowSettings] = useState(false);

  const handleLogout = () => { logout(); toast.success('Logged out'); };

  const currentShop = shops.find(s => s.id === Number(shopId));

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>

      {/* ── Sidebar ── */}
      <aside style={{
        width: 224, flexShrink: 0,
        background: '#0f172a',
        display: 'flex', flexDirection: 'column',
        borderRight: '1px solid #1e293b',
      }}>

        {/* Logo */}
        <div style={{ padding: '18px 16px 14px', borderBottom: '1px solid #1e293b'}}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 36, height: 36, borderRadius: 10,
            }}>
              <img src="/logo.jpg" alt="Logo" style={{ width: 36, height: 36, borderRadius: 6 }} />
            </div>
            <div>
              <div style={{ color: '#f1f5f9', fontSize: 13, fontWeight: 700, lineHeight: 1.2 }}>Meegoda</div>
              <div style={{ color: '#64748b', fontSize: 11 }}>Economic Center</div>
            </div>
          </div>
        </div>

        {/* Shop selector */}
        <div style={{ padding: '12px 12px 8px' }}>
          <div style={{ fontSize: 10, color: '#475569', textTransform: 'uppercase', letterSpacing: '.08em', marginBottom: 5 }}>
            Selected Shop
          </div>
          <select
            className="form-select"
            value={shopId || ''}
            onChange={e => onShopChange(e.target.value)}
            style={{ background: '#1e293b', color: '#e2e8f0', borderColor: '#334155', fontSize: 13 }}
          >
            <option value="">— All Shops —</option>
            {shops.map(s => (
              <option key={s.id} value={s.id}>{s.shop_code}</option>
            ))}
          </select>
          {currentShop && (
            <div style={{ marginTop: 5, fontSize: 11, color: '#64748b' }}>
              Editing: <span style={{ color: '#94a3b8', fontWeight: 600 }}>{currentShop.shop_code}</span>
            </div>
          )}
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, overflowY: 'auto', padding: '6px 8px' }}>

          {/* All shops overview */}
          <SidebarBtn
            icon="M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z"
            label="All Shops"
            active={!shopId}
            onClick={() => onShopChange('')}
          />

          {/* Divider */}
          <div style={{ margin: '6px 2px 8px', borderTop: '1px solid #1e293b' }} />

          {/* Section nav — only active when a shop is selected */}
          {NAV.map(item => (
            <SidebarBtn
              key={item.key}
              icon={item.icon}
              label={item.label}
              active={!!shopId && activeTab === item.key}
              disabled={!shopId}
              onClick={() => shopId && onTabChange(item.key)}
            />
          ))}
        </nav>

        {/* Bottom: user */}
        <div style={{ borderTop: '1px solid #1e293b' }}>
          {/* User row */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 12px 12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div style={{
                width: 30, height: 30, borderRadius: '50%',
                background: '#1d4ed8', display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 12, color: '#fff', fontWeight: 700, flexShrink: 0,
              }}>
                {username?.[0]?.toUpperCase()}
              </div>
              <div>
                <div style={{ color: '#e2e8f0', fontSize: 12, fontWeight: 500 }}>{username}</div>
                <div style={{ color: '#475569', fontSize: 10 }}>Administrator</div>
              </div>
            </div>
            <button
              onClick={handleLogout}
              title="Logout"
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#475569', padding: 4, borderRadius: 6, transition: 'color .15s' }}
              onMouseEnter={e => e.currentTarget.style.color = '#ef4444'}
              onMouseLeave={e => e.currentTarget.style.color = '#475569'}
            >
              <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/>
              </svg>
            </button>
          </div>
        </div>
      </aside>

      {/* ── Main content ── */}
      <main style={{ flex: 1, overflow: 'auto', background: 'var(--bg)' }}>
        {children}
      </main>

      {/* ── Settings modal ── */}
      {showSettings && <Settings onClose={() => setShowSettings(false)} />}
    </div>
  );
}
